import * as Colors from 'material-ui/styles/colors';

export default {
  textFieldHelpText: {
    padding: '0 15px',
    marginBottom: '10px',
    color: Colors.grey500
  },
  textFieldHelpTextLink: {
    color: Colors.green500,
    cursor: 'pointer'
  },
};
